import { z } from 'zod';

const UgCSPointSchema = z.object({
    latitude: z.number().min(-90).max(90),
    longitude: z.number().min(-180).max(180),
    altitude: z.number().optional(),
    altitudeType: z.string().optional()
});

const UgCSPolygonSchema = z.object({
    points: z.array(UgCSPointSchema).min(3)
});

const UgCSSegmentSchema = z.object({
    type: z.enum(['TakeOff', 'Landing', 'AreaScan']),
    point: UgCSPointSchema.optional(),
    polygon: UgCSPolygonSchema.optional()
});

const UgCSRouteSchema = z.object({
    name: z.string(),
    segments: z.array(UgCSSegmentSchema).min(1)
});

export const UGCS_MISSION_SCHEMA = z.object({
    mission: z.object({
        name: z.string().optional(),
        routes: z.array(UgCSRouteSchema).min(1)
    })
});
